import type { AppRouter } from "@sunfish/api";
import type { createTRPCClient } from "@trpc/client";
import type { LocalCheckIn } from "./db";
import { applyRemote, cacheRoster, getMeta, getOutbox, markSynced, setMeta } from "./store";

type Client = ReturnType<typeof createTRPCClient<AppRouter>>;

export async function runSync(client: Client, eventId: string): Promise<void> {
	const outbox = await getOutbox(eventId);
	if (outbox.length > 0) {
		const { acked } = await client.checkIn.pushCheckIns.mutate({
			rows: outbox.map((c) => ({
				clientId: c.clientId,
				attendeeId: c.attendeeId,
				direction: c.direction,
				source: c.source,
				voidsClientId: c.voidsClientId,
				occurredAt: c.occurredAt,
				claimedName: c.claimedName ?? null,
				claimedEmail: c.claimedEmail ?? null,
			})),
		});
		await markSynced(eventId, acked);
	}

	const roster = await client.checkIn.syncRoster.query();
	await cacheRoster(eventId, roster.attendees);

	const since = await getMeta(eventId, "pullCursor");
	const { checkIns, cursor } = await client.checkIn.pullCheckIns.query({ since });
	const incoming: LocalCheckIn[] = checkIns.map((c) => ({
		clientId: c.clientId,
		attendeeId: c.attendeeId,
		direction: c.direction,
		voidsClientId: c.voidsClientId,
		occurredAt: c.occurredAt,
		createdAt: c.createdAt ?? c.occurredAt,
		source: "manual",
		synced: 1,
	}));
	await applyRemote(eventId, incoming);
	if (cursor) await setMeta(eventId, "pullCursor", cursor);
}
